module.exports = __webpack_public_path__ + "static/media/kodini.20d6f6f1.png";